import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_PHARMACY_SALES_SUMMARY } from "../../action-types/actions";

import i18n from "../../i18n";
export const getPharmacySalesSummary = createAsyncThunk(
  ACTIONS_PHARMACY_SALES_SUMMARY.get_pharmacy_sales_summary,
  async ({ date_from, date_to }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getPharmacySalesSummary}`,
        { params: { date_from, date_to } },
      );
      if (response?.status === 200 || response?.data?.status === true) {
        return response.data;
      } else {
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || i18n.t("pharmacy.toast.failedToFetchSalesSummary");
      return rejectWithValue(errMsg);
    }
  },
);
